import EmojiRatingPage from "@components/EmojiRatingPage"

export default function CarsDataConfidencePage() {
  return (
    <EmojiRatingPage
      translationKey="carsDataConfidence"
      leftLabelKey="leftLabel"
      rightLabelKey="rightLabel"
    />
  )
}
